import { dtsAPI } from "../../axios";

export const actions = {

    // Process Type Requirement
    GetProcessTypeRequirement(context, data){
        return dtsAPI.get(`ProcessTypeRequirement/All/${data}`);
    },
    GetSingleProcessTypeRequirement(context, data){
        return dtsAPI.get(`ProcessTypeRequirement/${data}`);
    },
    UpdateProcessTypeRequirement(context, data){
        return dtsAPI.put(`ProcessTypeRequirement/${data.id}`, data);
    },
    DeleteProcessTypeRequirement(context, data){
        return dtsAPI.delete(`ProcessTypeRequirement/${data}`);
    },
    CreateProcessTypeRequirement(context, data){
        return dtsAPI.post(`ProcessTypeRequirement/Add`, data);
    },
}